import {Component, Input, OnChanges, OnInit} from '@angular/core';
import ApexCharts from 'apexcharts'


@Component({
    selector: 'timeline-chart',
    templateUrl: './timeline-chart.component.html',
    styleUrls: ['./timeline-chart.component.scss'],
    standalone: false
})

export class TimelineChartComponent implements OnInit {
  @Input() series;
  @Input() colors;
  @Input() id;

  public options = {
    chart: {
      type: 'area', height: 300, foreColor: '#999', stacked: true, dropShadow: { enabled: true, enabledSeries: [0], top: -2, left: 2, blur: 5, opacity: 0.06 },
      zoom: { enabled: false },
    },
    colors: ['#418AC9', '#1F4166'], stroke: { curve: 'smooth', width: 3 }, dataLabels: { enabled: false }, series: [],
    markers: { size: 0, strokeColor: '#fff', strokeWidth: 3, strokeOpacity: 1, fillOpacity: 1, hover: { size: 6 } }, fill: { type: 'solid', fillOpacity: 0.6 },
    xaxis: { type: 'datetime', axisBorder: { show: false }, axisTicks: { show: false } }, yaxis: { labels: { offsetX: 14, offsetY: -5 }, tooltip: { enabled: false } },
    grid: { padding: { left: -5, right: 5 } }, tooltip: { x: { format: 'dd MMM yyyy' }, }, legend: { position: 'top', horizontalAlign: 'left' }
  };
  constructor() {
  }

  ngOnInit() {
    this.renderChart();
  }

  renderChart() {
    if (!document.querySelector('#' + this.id + '-chart')) {
      return setTimeout(() => {
        this.renderChart();
      }, 100);
    }
    this.options.series = this.series;
    const chart = new ApexCharts(document.querySelector('#' + this.id + '-chart'), this.options);
    chart.render();
  }
}
